import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Hero from "./components/Hero";
import HomeSections from "./components/HomeSections";
import { InviteProvider } from "./components/ms/InviteContext";
import Groundwork from "./pages/Groundwork";
import About from "./pages/About";
import Angels from "./pages/Angels";
import Approach from "./pages/Approach";
import Program from "./pages/Program";
import Contact from "./pages/Contact";
import MavenCircle from "./pages/MavenCircle";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";

const Home = () => (
  <main className="min-h-screen w-full bg-[var(--ms-night-1)] text-[var(--ms-ink)]" data-testid="home-page">
    <Hero />
    <HomeSections />
  </main>
);

const ScrollToTop = () => {
  const { pathname, hash, key } = useLocation();
  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }
    const go = () => document.getElementById(hash.slice(1))?.scrollIntoView({ block: "start" });
    const t1 = setTimeout(go, 60);
    const t2 = setTimeout(go, 450);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [pathname, hash, key]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <InviteProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/approach" element={<Approach />} />
            <Route path="/program" element={<Program />} />
            <Route path="/angels" element={<Angels />} />
            <Route path="/mavencircle" element={<MavenCircle />} />
            <Route path="/groundwork" element={<Groundwork />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
        </InviteProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
